import httpRequest from 'httpRequest'
import {
    GiftCardSalePreviewContract,
    ReceiptBindingDataContract,
    ReceiptTemplateContract,
    ReceiptTemplateMarkupSlimModel,
    ReceiptTemplateSlimContract,
} from 'models'
import { ReceiptTemplateType } from 'constant/receiptTemplateType'

const RECEIPT_SERVICE = '/location/receipt-templates'

const receiptSettingService = {
    getReceiptTemplates: () => {
        return httpRequest.get<ReceiptTemplateSlimContract[]>(RECEIPT_SERVICE)
    },

    getReceiptTemplateId: (receiptID: string) => {
        return httpRequest.get<ReceiptTemplateContract>(
            `${RECEIPT_SERVICE}/${receiptID}`,
        )
    },

    getReceiptDataBinding: (receiptID: string) => {
        return httpRequest.get<ReceiptBindingDataContract>(
            `${RECEIPT_SERVICE}/${receiptID}/binding-data`,
        )
    },
    getBillPreview: (orderID: string) =>
        httpRequest.get<ReceiptBindingDataContract>(
            `${RECEIPT_SERVICE}/preview/${orderID}`,
        ),
    getBillPreviewByItems: (payload: string[]) =>
        httpRequest.post<ReceiptBindingDataContract[]>(
            `${RECEIPT_SERVICE}/preview/by-items`,
            payload,
        ),
    getGiftCardReceiptDataBinding: (giftCardSaleID: string) => {
        return httpRequest.get<ReceiptBindingDataContract>(
            `${RECEIPT_SERVICE}/gift-card/${giftCardSaleID}/binding-data`,
        )
    },

    getGiftCardTopupReceiptDataBinding: (giftCardSaleID: string) => {
        return httpRequest.get<ReceiptBindingDataContract>(
            `${RECEIPT_SERVICE}/gift-card/${giftCardSaleID}/top-up-binding-data`,
        )
    },

    getGiftCardPreviewDataBinding: (giftCardSaleID: string) => {
        return httpRequest.get<GiftCardSalePreviewContract>(
            `${RECEIPT_SERVICE}/gift-card/${giftCardSaleID}/preview`,
        )
    },

    getReceiptMarkup: () =>
        httpRequest.get<ReceiptTemplateMarkupSlimModel[]>(
            `${RECEIPT_SERVICE}/markups`,
        ),

    getAllDefaultReceiptMarkup: () =>
        httpRequest.get<ReceiptTemplateMarkupSlimModel[]>(
            `${RECEIPT_SERVICE}/markups/default`,
        ),

    deleteTemplates: (receiptTemplateIds: string[]) => {
        return httpRequest.delete(`${RECEIPT_SERVICE}`, {
            params: { receiptTemplateIds },
        })
    },

    updateTemplate: (receiptTemplate: ReceiptTemplateContract) => {
        return httpRequest.put(
            `${RECEIPT_SERVICE}/${receiptTemplate.receiptTemplateID}`,
            receiptTemplate,
        )
    },

    cloneTemplate: (template: ReceiptTemplateSlimContract) => {
        return httpRequest.post<ReceiptTemplateSlimContract>(
            `${RECEIPT_SERVICE}/${template.receiptTemplateID}/clone`,
            {},
            {
                params: {
                    name: template.name,
                    description: template.description,
                },
            },
        )
    },

    setDefaultTemplate: (templateId: string) => {
        return httpRequest.put(`${RECEIPT_SERVICE}/${templateId}/set-default`)
    },

    getTemplateByType: (receiptTemplateTypeId: ReceiptTemplateType) => {
        return httpRequest.get<ReceiptTemplateMarkupSlimModel>(
            `${RECEIPT_SERVICE}/types/${receiptTemplateTypeId}`,
        )
    },
}

export default receiptSettingService
